<template>
  <div>
    <v-card class="pa-3">
      <div class="query-container">
        <v-card-text>
          <v-textarea
            class="query ml-4 mr-4"
            solo
            name="query"
            label="Write your query here…"
            @input="verify()"
            v-model="textQuery">
          </v-textarea>
        </v-card-text>
      </div>
      <v-card-actions>
        <v-btn class="custom-btn" color="secondary" :disabled="!valid_"
          @click="confirm">Confirm
        </v-btn>
        <div v-if="!valid_" class="error-message ml-4">
          Query is not valid
        </div>
      </v-card-actions>
    </v-card>
  </div>
</div>
</template>

<script>
import {store} from "../../store/store";
    import axios from "axios";
    import * as _ from "lodash"

    export default {
        name: "CommunityQueryEditor",
        props: ['value'],
        data: () => ({
            textQuery: null,
            valid_: true
        }),
        mounted() {
            this.value ? this.textQuery = this.value : ''
            this.verify()
        },
        created () {
          this.verify = _.debounce(this.verify, 500)
        },
        methods:  {
          verify () {
            const token = store.state.accessToken;
            axios.post("/community/query/verify",
              JSON.stringify(this.textQuery), {
                headers: {"Authorization": "Bearer " + token,
                  "Content-type": "application/json"}
              })
              .then(resp => this.valid_ = true)
              .catch(err => this.valid_ = false)
          },
          confirm () {
            this.$emit('input', this.textQuery)
            this.$emit('confirm', this.textQuery)
          }
        },
        watch: {
            value (val, oldVal) {
              this.textQuery = val;
            }
        }
    }
</script>

<style>

</style>
